var rtlStyles = {"rtl":"IPgSD","ltr":"JCTML"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-f79b46f0.js.map
